/**
 * UVEditOverlay Component
 * EXACT PORT dari ModelViewerBACKUP.jsx line 8987-9178
 * 
 * UV Edit Mode indicator & controls
 * - Mode selector (Move, Scale, Rotate)
 * - Current values display
 * - Keyboard shortcut hints
 * - Exit button
 */

import React from 'react'

export default function UVEditOverlay({
  uvEditMode,
  selectedTexture,
  uvTransform,
  uvTransformMode,
  setUvTransformMode,
  onExit,
}) {
  if (!uvEditMode || !selectedTexture) return null

  return (
    <div
      style={{
        position: 'absolute',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '12px 20px',
        background:
          'linear-gradient(135deg, rgba(16, 185, 129, 0.75), rgba(5, 150, 105, 0.82))',
        backdropFilter: 'blur(20px) saturate(190%)',
        WebkitBackdropFilter: 'blur(20px) saturate(190%)',
        color: '#fff',
        border: '0.5px solid rgba(255, 255, 255, 0.22)',
        borderTop: '0.5px solid rgba(255, 255, 255, 0.3)',
        borderRadius: '12px',
        fontSize: '13px',
        fontWeight: 500,
        fontFamily: 'system-ui, -apple-system, sans-serif',
        boxShadow:
          '0 4px 12px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.12)',
        zIndex: 10,
        textAlign: 'center',
        minWidth: '350px',
        animation:
          'slideInFromTop 0.4s cubic-bezier(0.32, 0.72, 0, 1) 0.2s forwards',
        opacity: 0,
      }}
    >
      <div style={{ marginBottom: '4px' }}>🎮 UV Edit Mode</div>
      <div
        style={{
          fontSize: '10px',
          opacity: 0.9,
          marginBottom: '10px',
        }}
      >
        {selectedTexture.meshName} - {selectedTexture.type}
      </div>

      {/* Mode Selector Buttons */}
      <div
        style={{
          display: 'flex',
          gap: '6px',
          marginBottom: '10px',
        }}
      >
        <button
          onClick={() => setUvTransformMode('translate')}
          style={{
            flex: 1,
            padding: '6px 10px',
            backgroundColor:
              uvTransformMode === 'translate'
                ? 'rgba(0, 0, 0, 0.3)'
                : 'rgba(255, 255, 255, 0.1)',
            color: '#fff',
            border:
              uvTransformMode === 'translate'
                ? '2px solid #fff'
                : '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 600,
          }}
        >
          ↔ Move
        </button>
        <button
          onClick={() => setUvTransformMode('scale')}
          style={{
            flex: 1,
            padding: '6px 10px',
            backgroundColor:
              uvTransformMode === 'scale'
                ? 'rgba(0, 0, 0, 0.3)'
                : 'rgba(255, 255, 255, 0.1)',
            color: '#fff',
            border:
              uvTransformMode === 'scale'
                ? '2px solid #fff'
                : '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 600,
          }}
        >
          ⤢ Scale
        </button>
        <button
          onClick={() => setUvTransformMode('rotate')}
          style={{
            flex: 1,
            padding: '6px 10px',
            backgroundColor:
              uvTransformMode === 'rotate'
                ? 'rgba(0, 0, 0, 0.3)'
                : 'rgba(255, 255, 255, 0.1)',
            color: '#fff',
            border:
              uvTransformMode === 'rotate'
                ? '2px solid #fff'
                : '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 600,
          }}
        >
          ↻ Rotate
        </button>
      </div>

      {/* Current Values Display */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: '8px',
          fontSize: '9px',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          padding: '8px',
          borderRadius: '6px',
          marginBottom: '8px',
        }}
      >
        <div>
          <div style={{ opacity: 0.7 }}>Offset</div>
          <div style={{ fontWeight: 600 }}>
            {uvTransform.offsetX.toFixed(2)}, {uvTransform.offsetY.toFixed(2)}
          </div>
        </div>
        <div>
          <div style={{ opacity: 0.7 }}>Scale</div>
          <div style={{ fontWeight: 600 }}>
            {Math.abs(uvTransform.repeatX).toFixed(2)}, {uvTransform.repeatY.toFixed(2)}
          </div>
        </div>
        <div>
          <div style={{ opacity: 0.7 }}>Rotation</div>
          <div style={{ fontWeight: 600 }}>
            {((uvTransform.rotation * 180) / Math.PI).toFixed(0)}°
          </div>
        </div>
      </div>

      {/* Instructions */}
      <div
        style={{
          fontSize: '9px',
          opacity: 0.85,
          lineHeight: 1.4,
        }}
      >
        {uvTransformMode === 'translate' && '🖱 Drag anywhere to move texture position'}
        {uvTransformMode === 'scale' && '🖱 Drag or wheel to scale texture'}
        {uvTransformMode === 'rotate' && '🖱 Drag or wheel to rotate texture'}
        <div
          style={{
            marginTop: '4px',
            fontSize: '8px',
            opacity: 0.7,
          }}
        >
          Shortcuts: G=Move • R=Rotate • S=Scale • ESC=Exit
        </div>
      </div>
    </div>
  )
}

